import React, { useState } from 'react';
import { apiBaseUrl } from '../utils';

const Footer = () => {
    const [question, setQuestion] = useState('');
    const [email, setEmail] = useState('');
    const [newsletter, setNewsletter] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email.trim()) { setError('Email is required'); return; }
        setError('');
        fetch(`${apiBaseUrl}/api/contact`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ question, email, newsletter }),
        })
        .then((res) => { if (res.ok) { setSent(true); setQuestion(''); setEmail(''); setNewsletter(false); } })
        .catch(() => setError('Something went wrong'));
    };

    return (<>
        <style>{`
          footer a, footer a:visited { color: #d0d0d0 !important; }
          footer a:hover { color: #fff !important; }
        `}</style>
        <div className="relative overflow-hidden w-full h-1">
            <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-green-500 to-green-500"></div>
        </div>
        <footer className="mt-0 text-center bg-black text-white flex flex-col items-center justify-center py-3" style={{ fontFamily: "Arial, Helvetica, sans-serif" }}>

           {/* Contact form */}
           <div style={{ width: "100%", maxWidth: "800px", padding: "0 24px", margin: "0 auto" }}>
             {sent ? (
               <p style={{ color: "#1FE2A5", fontSize: "14px" }}>Thank you! We'll be in touch.</p>
             ) : (
               <form onSubmit={handleSubmit} style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap", justifyContent: "center" }}>
                 <input
                   type="text"
                   placeholder="Question (optional)"
                   value={question}
                   onChange={(e) => setQuestion(e.target.value)}
                   style={{ background: "#111", border: "1px solid #333", borderRadius: "25px", padding: "8px 16px", color: "#fff", fontSize: "13px", flex: "1 1 180px", minWidth: "140px", outline: "none" }}
                 />
                 <input
                   type="email"
                   placeholder="Email *"
                   value={email}
                   onChange={(e) => { setEmail(e.target.value); setError(''); }}
                   required
                   style={{ background: "#111", border: error ? "1px solid #ef4444" : "1px solid #333", borderRadius: "25px", padding: "8px 16px", color: "#fff", fontSize: "13px", flex: "1 1 160px", minWidth: "140px", outline: "none" }}
                 />
                 <label style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "12px", color: "rgba(255,255,255,0.5)", cursor: "pointer", whiteSpace: "nowrap" }}>
                   <input type="checkbox" checked={newsletter} onChange={(e) => setNewsletter(e.target.checked)} style={{ accentColor: "#1FE2A5" }} />
                   Newsletter
                 </label>
                 <button
                   type="submit"
                   style={{ background: "linear-gradient(135deg, #1FE2A5 0%, #14b882 100%)", color: "#000", fontWeight: 700, fontSize: "13px", padding: "8px 24px", borderRadius: "25px", border: "none", cursor: "pointer", whiteSpace: "nowrap" }}
                 >
                   Submit
                 </button>
               </form>
             )}
             {error && <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>{error}</p>}
           </div>

           <div style={{ height: "12px" }} />
           <div className="flex justify-center items-center gap-4 w-full">
               <a href="mailto:info@dnc.de" style={{ fontSize: "14px", textDecoration: "none" }}>info@dnc.de</a>
               <span style={{ color: "rgba(255,255,255,0.2)" }}>|</span>
               <span>&copy; 2024 - 2026 AUCDOM.COM</span>
           </div>
           <div className="text-gray-500 text-sm">
               a service of <a href="https://ewbcd.com/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white hover:underline">EWBCD GmbH</a>
           </div>
       </footer>
    </>);
};

export default Footer;
